import {
  parseJsonToEditorState,
  parseReadOnly,
  convertEditorStateToHTML,
} from '../../services/editorJS/utils';
import { EditorJsParserParams } from '../../services/editorJS/EditorJsParser';
import { StreamMeta } from './record/UploadRecordContext';

export enum ScreenType {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export const PrompterConfig = {
  guide: true,
  speedDelta: 0.1,
  minSpeed: 0.1,
  maxSpeed: 10,
  scrollIntervalMs: 5, // Timer interval
  scrollScalar: 1.0 / 60.0, // scaling-factor applied to the speed setting, on each interval
  fontSizeDelta: 1,
  minFontSize: 12, // Overall minimum font size
  highlightGuide: 6.0,
  minHeightPrompter: 200,
  fontSize: {
    [ScreenType.Small]: {
      buttonSmallFontSize: 12,
      buttonMediumFontSize: 24,
      buttonLargeFontSize: 36,
    },
    [ScreenType.Medium]: {
      buttonSmallFontSize: 18,
      buttonMediumFontSize: 36,
      buttonLargeFontSize: 64,
    },
    [ScreenType.Large]: {
      buttonSmallFontSize: 24,
      buttonMediumFontSize: 48,
      buttonLargeFontSize: 72,
    },
  },

  speedScalarMobile: 2.0,
  speedScalarTablet: 1.5,
  cameraStopRecordingWhenPrompterEnds: false
};

export const parseScript = (textScript: string, params?: EditorJsParserParams): string => convertEditorStateToHTML(
  parseReadOnly(
    parseJsonToEditorState(textScript),
  ),
  params,
);

export const downloadStream = (stream: StreamMeta, fileName:string, blobType:string) => {
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.style.display = 'none';
  const blob = new Blob(stream.blob, {
    type: blobType,
  });
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
